import React, { useState, useEffect } from 'react'
import API from '../../../../config/api';
import swal from 'sweetalert';
import {
    Attachment, AttachmentImage, BackArrow, Container, Header,
    Label, ModalContainer, Section, StatusSelect, TitleHeader,
    UpdateButton, UpdateButtonRejected, Value
} from '../components/ModalReimbusement';
import styled from 'styled-components';

const TextArea = styled.textarea`
  width: 100%;
  min-height: 80px;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 14px;
  margin-top: 8px;
  resize: vertical;
`;

const ModalDetail = (props) => {
    const { openModal, handlCLose, data, getReimbursement, setData, setTypeModal, employee } = props
    const token = localStorage.getItem('token')

    const [status, setStatus] = useState(data?.status || 'pending');
    const [reason, setReason] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (data?.status) setStatus(data.status);
        setReason(data?.notes);
    }, [data]);

    const onClose = () => {
        handlCLose();
        setData('')
        setReason('');
    }

    const formatRupiah = (number) => {
        return new Intl.NumberFormat("id-ID", {
            style: "currency",
            currency: "IDR",
            minimumFractionDigits: 0
        }).format(number);
    };

    const formatTanggalIndonesia = (tanggalString) => {
        const tanggal = new Date(tanggalString);
        return new Intl.DateTimeFormat('id-ID', {
            weekday: 'long',
            day: '2-digit',
            month: 'long',
            year: 'numeric'
        }).format(tanggal);
    };

    const handleStatusApproved = () => {

        setLoading(true);
        const payload = new FormData();
        payload.append('status', "approved");
        if (status !== 'pending') {
            payload.append('notes', reason || '');
        }

        API.editStatusReimbursement(token, data?.id, payload, employee?.id)
            .then(res => {
                swal("Berhasil", "Status berhasil diupdate", "success");
                getReimbursement();
                onClose();
            })
            .catch(err => {
                swal("Gagal", "Terjadi kesalahan saat mengupdate status", "error");
            })
            .finally(() => {
                setLoading(false);
            });
    }
    const handleStatusRejected = () => {

        setLoading(true);
        const payload = new FormData();
        payload.append('status', "rejected");
        if (status !== 'pending') {
            payload.append('notes', reason || '');
        }

        API.editStatusReimbursement(token, data?.id, payload, employee?.id)
            .then(res => {
                swal("Berhasil", "Status berhasil diupdate", "success");
                getReimbursement();
                onClose();
            })
            .catch(err => {
                swal("Gagal", "Terjadi kesalahan saat mengupdate status", "error");
            })
            .finally(() => {
                setLoading(false);
            });
    }

    return (
        openModal && (
            <ModalContainer>
                <Container>
                    <Header>
                        <BackArrow onClick={onClose}>&#8592;</BackArrow>
                        <TitleHeader>Reimbursement Details</TitleHeader>
                    </Header>

                    <Section>
                        <Label>Nama Karyawan</Label>
                        <Value>{data?.name}</Value>
                    </Section>
                    <Section>
                        <Label>Nominal</Label>
                        <Value>{formatRupiah(data?.amount)}</Value>
                    </Section>
                    <Section>
                        <Label>Tanggal Pengeluaran</Label>
                        <Value>{formatTanggalIndonesia(data?.date_incurred)}</Value>
                    </Section>
                    <Section>
                        <Label>Keterangan Pengganti</Label>
                        <Value>{data?.description}</Value>
                    </Section>
                    <Section>
                        <Label>Rekening Karyawan</Label>
                        <Value>{data?.bank_name} - {data?.number} a/n {data?.account_name}</Value>
                    </Section>
                    {
                        data?.paid_at &&

                        <Section>
                            <Label>Tanggal Penggantian Biaya</Label>
                            <Value>{formatTanggalIndonesia(data?.paid_at)}</Value>
                        </Section>
                    }
                    {
                        data?.status != 'paid' && data?.status != 'canceled' ?
                            <>

                                <Section>
                                    <Label>Alasan </Label>
                                    <TextArea
                                        placeholder={`Masukkan alasan `}
                                        value={reason}
                                        onChange={(e) => setReason(e.target.value)}
                                    />
                                </Section>


                                <Section style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
                                    <UpdateButton onClick={handleStatusApproved} disabled={loading}>
                                        {loading ? 'Updating...' : 'Approved'}
                                    </UpdateButton>
                                    <UpdateButtonRejected onClick={handleStatusRejected} disabled={loading}>
                                        {loading ? 'Updating...' : 'Rejected'}
                                    </UpdateButtonRejected>
                                </Section>
                            </>
                            : ""
                    }

                    <Section style={{ marginBottom: "150px" }}>
                        <Label>Lampiran</Label>
                        {data?.attachments?.map((at, i) => (
                            <Attachment key={i}>
                                <AttachmentImage src={at?.file_url} />
                            </Attachment>
                        ))}
                    </Section>
                </Container>
            </ModalContainer>
        )
    );
}

export default ModalDetail;
